import ParkingSpotMap from "./parkingSpotMap";

export default ParkingSpotMap;